module.exports = __webpack_public_path__ + "img/facebook-icon-blue.c474fabd.svg";